'use client';

import * as Accordion from '@radix-ui/react-accordion';

import { FaqAccordionItem, FaqItem } from './faq-accordion';
import { mergeClassNames } from '@/lib/utils';
import { Separator } from '@mokoboko/components';

// No loading state: whether there are any FAQs is unknown until they load, and
// a placeholder for a section that turns out empty collapsed under the reader.
// It is always the last section, so arriving late moves nothing.
export const FaqSection = ({
  faqs,
  className,
  compact = false,
}: {
  faqs: FaqItem[];
  className?: string;
  compact?: boolean;
}) => (
  <div
    className={mergeClassNames('flex flex-col gap-4 max-sm:pt-3', className)}
  >
    <div className="flex flex-col gap-1">
      <h2 className="heading-section">FAQ</h2>
      <p className="text-sm text-gray-700">
        Frequently asked questions, answered
      </p>
    </div>

    <Accordion.Root type="single" collapsible defaultValue="item-0">
      {faqs.map((faq, index) => (
        <div key={index}>
          <FaqAccordionItem
            faq={faq}
            value={`item-${index}`}
            isLast={index === faqs.length - 1}
            compact={compact}
          />
          {index < faqs.length - 1 && <Separator />}
        </div>
      ))}
    </Accordion.Root>
  </div>
);
